import { Component, Input, ChangeDetectionStrategy, ViewChild, ElementRef, OnInit, NgZone } from '@angular/core';
import { AccountReponseData } from '../../interfaces/account';
import { UserSearchDeliveryLocationInfo, DeliveryLocationResponseData } from '../../interfaces/delivery';
import { ApiService } from '../../service/api.service';
import { LocalStorageService } from '../../service/localstorage.service';
import { UserService } from '../../service/user.service';

interface Page {
  page: string,
  link: string
}

@Component({
  selector: 'bevvi-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})

export class BreadcrumbComponent implements OnInit {

  @Input()
  pageName: Array<Page>;

  @Input()
  userAddress: string;

  @Input()
  editableAddress: boolean = false;

  @Input()
  addGrey: boolean = false;

  @ViewChild('searchMap', { static: true })
  public searchElementRef: ElementRef;

  @ViewChild('dropDown', { static: false })
  public dropDownRef: ElementRef

  private latitude: number;
  private longitude: number;
  private formattedAddress: string;
  private isLoading: boolean = true;
  public addressError: boolean = false;
  public userSearchDeliveryInfo: UserSearchDeliveryLocationInfo;
  public isLoggedIn: boolean = false;
  public errorMsg: string;
  public searchAddress: string;
  public userAddressObject: object = {};
  public isRecipientPage: boolean = false;

  constructor(
    private apiService: ApiService,
    private localStorageService: LocalStorageService,
    private userService: UserService,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    // console.log('BreadCrumb is Loaded');
    this.searchAddress = this.userAddress;
    // console.log(this.searchAddress)
    this.userService.isRecipientPageSubject
      .subscribe(
        (flag: boolean) => {
          if (flag) {
            this.isRecipientPage = true;
          } else {
            this.isRecipientPage = false;
          }
        }
      )
  }

  updateAddress() {
    if (this.editableAddress) {
      // console.log('Inside');
      // console.log(this.searchElementRef);
      this.isLoggedIn = this.localStorageService.isLoggedIn();
      let autoComplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        types: ["address"]
      });

      autoComplete.addListener("place_changed", () => {
        let place: google.maps.places.PlaceResult = autoComplete.getPlace();
        // console.log(place);

        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
        this.formattedAddress = place.formatted_address;
        // console.log(this.latitude)
        // console.log(this.longitude)
        place.address_components.forEach(data => {
          let type = data.types[0];
          let shortName = data.short_name;
          this.userAddressObject[type] = shortName
        })

        // console.log(place)
        this.clickSaveLocation();
      });
    }
  }

  clickSaveLocation() {
    // console.log('Form Submit');
    // console.log('Loading: ' + this.isLoading)
    if (this.isLoading) {
      this.isLoading = !this.isLoading;
      // console.log(this.userAddressObject)
      // Object.keys(this.userAddressObject).forEach((key) => {
      // if (key === 'administrative_area_level_1') {
      //   if (this.userAddressObject[key] === 'CA') {
      //     this.localStorageService.setCaliforniaProposition(true);
      //   } else {
      //     this.localStorageService.setCaliforniaProposition(false);
      //   }
      // }
      // })
      // if (this.userAddressObject)
      if (this.latitude != null || this.longitude != null) {
        this.userSearchDeliveryInfo = {
          geoLocation: {
            coordinates: [
              this.longitude,
              this.latitude
            ],
            type: "Point"
          },
          address: this.formattedAddress
        }
      };
      let stateName;
      let zipCode;
      // console.log(this.userAddressObject);
      Object.keys(this.userAddressObject).forEach((key) => {
        if (key === 'administrative_area_level_1') {
          stateName = this.userAddressObject[key]
        } else if (key === 'postal_code') {
          zipCode = this.userAddressObject[key]
        }
      })

      if (this.isLoggedIn) {
        let deliveryData = {
          accountId: this.localStorageService.getCurrentAccountID(),
          geoLocation: {
            coordinates: [
              this.longitude,
              this.latitude
            ],
            type: "Point"
          },
          address: this.formattedAddress
        };

        let updateData = {
          addressComponent: this.userAddressObject
        }
        let param = {
          "currentAccountId": this.localStorageService.getCurrentAccountID(),
          "accessToken": this.localStorageService.getAccessToken(),
        }
        this.apiService.putData(this.apiService.constants.ACCOUNT_DATA_API, updateData, param, true)
          .subscribe(
            (accountResponseData: AccountReponseData) => {
              this.localStorageService.setUserAddressComponent(updateData);
              this.apiService.postData(this.apiService.constants.UPDATE_ACCOUNT_ON_REMARKETY, '', param, true)
                .subscribe();
            }
          )

        this.apiService.postData(this.apiService.constants.ADD_DELIVERY_LOCATION_API, deliveryData, {}, false)
          .subscribe(
            (deliveryLocationData: DeliveryLocationResponseData) => {
              this.localStorageService.setUserSearchGeoLocationAddress(deliveryLocationData.address);
              this.localStorageService.setUserSearchGeoLocationPoint(deliveryLocationData.geoLocation);
              // this.userService.locationInfo(true);
              this.userAddress = this.userSearchDeliveryInfo.address;

              let params = {
                geoLocationParams: JSON.stringify(this.userSearchDeliveryInfo.geoLocation),
                currentAccountId: this.localStorageService.getCurrentAccountID(),
                stateName: stateName,
                zipCode: zipCode
              }
              this.userService.locationInfo(true);
              this.apiService.getData(this.apiService.constants.GET_ESTABLISHMENTID_BYACCOUNTID, params, true)
                .subscribe(
                  (data) => {
                    // this.oldEstablishmentIDData = this.localStorage.getEstablishmentIDofAddress();
                    this.localStorageService.setEstablishmentIDofAddress(data)
                    this.ngZone.run(() => {
                      this.isLoading = true;
                      this.callForChanges();
                    });
                  },
                  error => {
                    console.log(error)
                  }
                )
            },
            error => {
              this.isLoading = false;
            }
          )
      } else {
        this.localStorageService.setUserSearchGeoLocationAddress(this.userSearchDeliveryInfo.address);
        this.localStorageService.setUserSearchGeoLocationPoint(this.userSearchDeliveryInfo.geoLocation);
        // this.userService.locationInfo(true);
        this.isLoading = true;

        let params = {
          geoLocationParams: JSON.stringify(this.userSearchDeliveryInfo.geoLocation),
          stateName: stateName,
          zipCode: zipCode
        }
        this.apiService.getData(this.apiService.constants.GET_ESTABLISHMENTID_BYGEOLOCATION, params, true)
          .subscribe(
            (data) => {
              // this.oldEstablishmentIDData = this.localStorageService.getEstablishmentIDofAddress();
              this.localStorageService.setEstablishmentIDofAddress(data)
              this.ngZone.run(() => {
                this.userAddress = this.userSearchDeliveryInfo.address;
                this.callForChanges();
              });
            },
            error => {
              console.log(error)
            }
          )
      }


    } else {
      this.isLoading = !this.isLoading;
      this.addressError = true;
      this.errorMsg = "valid address required.";
    }
  }

  callForChanges() {
    this.dropDownRef.nativeElement.click();
    // this.userAddress = this.userSearchDeliveryInfo.address;
    this.userService.locationAddress(true);
    // console.log('Call For Change')
  }

}
